import { Color } from '../entities/Color';
import { ComponentKewlox } from './ComponentKewlox';
import { DoorHandleEntity, SearchInfo } from '../Data';
import { getColors } from '../utils/dataStorage';
import { DoorHandleType, STANDARD_COLOR } from '../constants';
import { findColor } from '../utils/colorHelper';
import { findDoorHandle } from '../utils/piecesUpdater';

export class DoorHandle extends ComponentKewlox {
  readonly type: DoorHandleType;
  readonly color?: Color;

  static _lookup = ['height'];

  constructor(
    id: number,
    name: string,
    reference: string,
    price: number,
    weigth: number,
    forSale: boolean,
    visible: boolean,
    height: number,
    type: DoorHandleType,
    color?: Color,
  ) {
    super(id, name, reference, price, weigth, forSale, visible, height);
    this.type = type;
    if (color) this.color = color;
  }

  get typeComponent() {
    return 'DoorHandle';
  }

  static fromJSON(json: DoorHandleEntity): DoorHandle {
    const obj = Object.create(DoorHandle.prototype);
    Object.assign(obj, this, json);

    if (json.color) {
      let objColor: Color;
      if (typeof json.color === 'number') {
        const colors = getColors();
        objColor = colors[0];
        for (const colorItem of colors) {
          if (colorItem.id === json.color) {
            objColor = colorItem;
          }
        }
      } else {
        objColor = json.color as Color;
      }

      Object.assign(obj, {
        color: objColor,
      });
    }
    return obj;
  }

  static reviver(key: string, value: any): any {
    return key === '' ? DoorHandle.fromJSON(value) : value;
  }

  compareTo(otherComponent: ComponentKewlox): number {
    return this.height - otherComponent.height;
  }

  static getSearchInfos(type: DoorHandleType, color?: Color): SearchInfo {
    const height = 1;
    const colorId = color ? color.id : undefined;
    return {
      lookup: this._lookup,
      key: { height, type, color: colorId },
    };
  }

  getKey(): string {
    return DoorHandle.generateKey(this.type, this.color);
  }

  static generateKey(type: DoorHandleType, color?: Color) {
    let searchInfos = DoorHandle.getSearchInfos(type, color);
    return JSON.stringify(searchInfos.key);
  }

  static standardHandle(): DoorHandle {
    const doorHandle = findDoorHandle(
      DoorHandleType.Knop,
      findColor(STANDARD_COLOR),
    );
    if (!doorHandle) throw new Error("Can't find the default knop");

    return doorHandle;
  }
}
